import { Route, Switch } from 'react-router-dom'
import { ROUTER_PATH } from './metaData'

// Common
import NotFoundPage from '../404/NotFoundPage'
import DefaultAdminScreen from '../default/DefaultAdminScreen'
import ProfileScreen from '../profile'

import AccountScreen from '../account'
import FundScreen from '../fund'
import AccountCreateScreen from '../account/form'
import FundCreateScreen from '../fund/form'
import PromotionScreen from '../promotion'
import PromotionCreateScreen from '../promotion/form'
import CommonConfigScreen from '../common-config'
import PriceScreen from '../price'
import TripScreen from '../trip'
import TripCreateScreen from '../trip/form'
import ProvinceCreateScreen from '../province/form'
import ProvinceScreen from '../province'
import LocationScreen from '../location'
import LocationCreateScreen from '../location/form'
import UserHomePage from '../user-home-page'

const AdminRouters = (props: any) => {
   return (
      <Switch>
         {/* Common */}
         <Route exact path={`/`} component={UserHomePage} />
         {/* <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountScreen}`} component={AccountScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountCreateScreen}`} component={AccountCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountUpdateScreen}`} component={AccountCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.AccountDetailScreen}`} component={AccountCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundScreen}`} component={FundScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundCreateScreen}`} component={FundCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundUpdateScreen}`} component={FundCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundDetailScreen}`} component={FundCreateScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.PromotionScreen}`} component={PromotionScreen} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionCreateScreen}`}
            component={PromotionCreateScreen}
         />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionUpdateScreen}`}
            component={PromotionCreateScreen}
         />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.PromotionDetailScreen}`}
            component={PromotionCreateScreen}
         />
         <Route exact path={`${props.match.url}${ROUTER_PATH.CommonConfigScreen}`} component={CommonConfigScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.PriceScreen}`} component={PriceScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripScreen}`} component={TripScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripCreateScreen}`} component={TripCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripUpdateScreen}`} component={TripCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TripDetailScreen}`} component={TripCreateScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceScreen}`} component={ProvinceScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceCreateScreen}`} component={ProvinceCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceUpdateScreen}`} component={ProvinceCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProvinceDetailScreen}`} component={ProvinceCreateScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationScreen}`} component={LocationScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationCreateScreen}`} component={LocationCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationUpdateScreen}`} component={LocationCreateScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.LocationDetailScreen}`} component={LocationCreateScreen} /> */}
         {/* Not Found */}
         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default AdminRouters
